import React, { useEffect, useState } from 'react';
import { getCurrentUser, redirectToLogin } from '../lib/auth';

/**
 * Protected Route Component - Requires Cloudflare Access Authentication
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {React.ReactElement} Route component with authentication
 */
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser && currentUser.authenticated) {
          setUser(currentUser);
        } else {
          // No valid user, redirect to Cloudflare Access login
          redirectToLogin();
          return;
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        redirectToLogin();
        return;
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-gray-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
